/**
 * View mode for the project landing page.
 * Persisted in URL search param: ?view=table | map | split
 */
export type ProjectViewMode = 'table' | 'map' | 'split';

export const PROJECT_VIEW_PARAM = 'view';

export const DEFAULT_VIEW_MODE: ProjectViewMode = 'split';

export function isValidViewMode(value: string): value is ProjectViewMode {
  return value === 'table' || value === 'map' || value === 'split';
}
